import { DutyRosterManagement } from "@/components/dutyRoster/DutyRosterManagement";

const DutyRosterManagementPage = () => {
  return <DutyRosterManagement />;
};

export default DutyRosterManagementPage;
